export type IAppRegion = 'crowdaa-dev-us' | 'crowdaa-us' | 'crowdaa-fr';

export type IAppRegionSettings = {
  name: string;
  countryCode: string;
  apiUrl: string;
  rootAppId: string;
  previewUrl: string;
  legacyDashboardUrl: string;
  legacyCrowdUrl: string;
};

export type IAppRegionsSettings = Record<IAppRegion, IAppRegionSettings>;

const TARGET_API_URL = import.meta.env.CROWDAA_TARGET_API_URL?.trim();
const TARGET_ROOT_APP_ID = import.meta.env.CROWDAA_TARGET_ROOT_APP_ID?.trim();

const getApiUrl = (fallbackApiUrl: string): string =>
  TARGET_API_URL && TARGET_API_URL.length > 0 ? TARGET_API_URL : fallbackApiUrl;

const getRootAppId = (fallbackRootAppId: string): string =>
  TARGET_ROOT_APP_ID && TARGET_ROOT_APP_ID.length > 0
    ? TARGET_ROOT_APP_ID
    : fallbackRootAppId;

export const appRegionsSettings: IAppRegionsSettings = {
  'crowdaa-dev-us': {
    name: 'dev-us',
    countryCode: 'us',
    apiUrl: getApiUrl('https://dev-api.aws.crowdaa.com/v1'),
    rootAppId: getRootAppId('nQ9ZO9DEgfaOzWY44Xu2J2uaPtP92t176PpBkdqu'),
    previewUrl: 'https://preview-app-dev-us.crowdaa.com',
    legacyDashboardUrl: 'https://dev-blog.crowdaa.com',
    legacyCrowdUrl: 'https://dev-crowd.crowdaa.com',
  },
  'crowdaa-us': {
    name: 'prod-us',
    countryCode: 'us',
    apiUrl: getApiUrl('https://api.aws.crowdaa.com/v1'),
    rootAppId: getRootAppId('nQ9ZO9DEgfaOzWY44Xu2J2uaPtP92t176PpBkdqu'),
    previewUrl: 'https://preview-app-us.crowdaa.com',
    legacyDashboardUrl: 'https://blog.crowdaa.com',
    legacyCrowdUrl: 'https://crowd.crowdaa.com',
  },
  'crowdaa-fr': {
    name: 'prod-fr',
    countryCode: 'fr',
    apiUrl: getApiUrl('https://fr48ta99mc.execute-api.eu-west-3.amazonaws.com/prod'),
    rootAppId: getRootAppId('nQ9ZO9DEgfaOzWY44Xu2J2uaPtP92t176PpBkdqu'),
    previewUrl: 'https://ghanty-preview-app-prod-fr-239861161032.s3.eu-west-3.amazonaws.com',
    legacyDashboardUrl: 'https://d1ic7c3f8ht6to.cloudfront.net',
    legacyCrowdUrl: 'https://d1ic7c3f8ht6to.cloudfront.net',
  },
};
